<template>
    <div class="name targeting-block">
        <div class="title">
            <span>{{ label }}</span>
            <input
                v-if="showCampaignIdInput"
                :value="campaignApiId"
                @input="onCampaignApiIdInput"
                type="text"
                class="campaign-id-input"
            />
            <img v-if="!localName" alt="red_star" class="is-empty" src="/images/red_star.svg" />
        </div>
        <div class="input-data">
            <input v-model="localName" @input="onInput" class="campaign-name" type="text" :placeholder="placeholder" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'Name',
    props: {
        label: {
            type: String,
            default: 'Название кампании',
        },
        placeholder: {
            type: String,
            default: 'Название кампании',
        },
        campaignApiId: {
            type: String,
            default: '',
        },
        showCampaignIdInput: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            localName: this.name || '',
        };
    },

    watch: {
        name(newVal) {
            this.localName = newVal || '';
        },
    },

    methods: {
        onInput(e) {
            this.$emit('update:name', this.localName);
            this.validateInput(e);
        },
        validateInput(e) {
            // Убираем только опасные символы, но оставляем пробелы
            const cleanedValue = e.target.value.replace(/[\/\\]/g, '');
            this.localName = cleanedValue;
        },
        onCampaignApiIdInput(e) {
            // Обрезаем пробелы и обновляем значение
            this.$emit('update:campaignApiId', e.target.value.trim());
        },
    },
};
</script>
